export const NUMBER_OF_SLOTS_PER_DAY = 4;
export const HOURS_BETWEEN_SLOTS = 24 / NUMBER_OF_SLOTS_PER_DAY;
export const HOURS_IN_THE_DAY = 24;
export const BOXPLOT_HEATMAP_CHART_SLOT_CATEGORIES = ["0", "6", "12", "18"];
export const BOXPLOT_HEATMAP_CHART_WEEK_DAYS_CATEGORIES = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const BOXPLOT_HEATMAP_CHART_WEEK_DAYS_CATEGORIES_PT_BR = [
  "Segunda",
  "Terça",
  "Quarta",
  "Quinta",
  "Sexta",
  "Sábado",
  "Domingo",
];
